import '../styles/SkillSlider.css';

const SkillSlider = ({ skill, level }) => {
  return (
    <div className="skill-slider">
      <p>{skill}</p>
      <div className="slider-container">
        <div className="slider-bar" style={{ width: `${level}%` }}></div>
      </div>
    </div>
  );
};

export default SkillSlider;